import React, {
  useCallback, useState, useContext, useEffect,
} from 'react';
import {
  Grid,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  IconButton,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { selectUploadMedia } from '../../../../store/modules/articles/selectors';
import { setOpenMediaUpload } from '../../../../store/modules/articles/actions';
import { UploadPanelStyles } from './styles';
import { UploadContext } from '../useUploadFiles';
import Preview from './Preview';
import CloseAction from './CloseAction';
import UploadTitle from './UploadTitle';

const UploadPanel = () => {
  const classes = UploadPanelStyles();
  const dispatch = useDispatch();
  const { open: isOpen } = useSelector(selectUploadMedia);
  const [expanded, setExpanded] = useState(true);
  const { files, downloadFiles } = useContext(UploadContext);;

  useEffect(() => {
    if (isOpen && files.length === 0 && downloadFiles.length === 0) {
      dispatch(setOpenMediaUpload(false));
    } else {
      if (!isOpen) {
        const uploadingFiles = files.filter(
          (item) => item.meta.status === 'uploading' || item.meta.status === 'ready',
        ).length;
        const downloadingFiles = downloadFiles.filter(
          (item) => item.status === 'downloading',
        ).length;

        if (uploadingFiles > 0 || downloadingFiles > 0) {
          dispatch(setOpenMediaUpload(true));
        }
      }
    }
  }, [files, downloadFiles, isOpen, dispatch]);

  const onExpand = useCallback(() => {
    setExpanded(!expanded);
  }, [expanded, setExpanded]);

  const closeHandler = useCallback(() => {
    dispatch(setOpenMediaUpload(false));
  }, [dispatch]);

  return (
    <ExpansionPanel
      expanded={expanded}
      hidden={!isOpen}
      className={classes.root}
      onChange={() => {}}
    >
      <ExpansionPanelSummary className={classes.header}>
        <Grid container alignItems="center">
          <Grid item style={{ maxWidth: 250 }}>
            <UploadTitle />
          </Grid>
          <Grid item className={classes.actionContainer}>
            <IconButton onClick={onExpand} className={classes.headerAction}>
              <ExpandMoreIcon className={clsx(classes.icon, expanded ? classes.expanded : '')} />
            </IconButton>
            <CloseAction closeUploadPanel={closeHandler} />
          </Grid>
        </Grid>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={classes.detailPanel}>
        <Grid container alignItems="baseline" style={{ padding: 10 }}>
          {files.map((item) => <Preview file={item} key={item.meta.id} />)}
          {downloadFiles.map((item) => <Preview downloadFile={item} key={item.downloadId} />)}
        </Grid>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

export default UploadPanel;
